import { render } from "./LanguageComponent.vue?vue&type=template&id=0c778d7f"
import script from "./LanguageComponent.vue?vue&type=script&lang=js"
export * from "./LanguageComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Language/LanguageComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c778d7f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c778d7f', __exports__)) {
    api.reload('0c778d7f', __exports__)
  }
  
  module.hot.accept("./LanguageComponent.vue?vue&type=template&id=0c778d7f", () => {
    api.rerender('0c778d7f', render)
  })

}


export default __exports__